import React, { useState } from 'react';

import { connect } from 'react-redux';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import * as ApplicationMessageActions from '../actions/applicationMessageActions';

import classes from './Snackbar.module.css';

const Alert = props => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const SnackBar = ({
    notifications,
    removeSnackbar
}) => {
    const [ isOpen, setIsOpen ] = useState(true);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            removeSnackbar(notifications[0].key);
            return;
        }

        setIsOpen(false);
        removeSnackbar(notifications[0].key);
        setIsOpen(true);
    };

    if (!notifications || !notifications.length) {
        return null;
    }

    const Snack = () => {
        return (
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                classes={{
                    root: classes.Snackbar
                }}
                open={isOpen}
                autoHideDuration={5000}
                onClose={handleClose}
            >
                <Alert severity={notifications[0].status} onClose={handleClose}>
                    {notifications[0].notification}
                </Alert>
            </Snackbar>
        );
    };

    return (
        <Snack />
    );
};

const mapStateToProps = state => {
    return {
        notifications: state.messages.notifications
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions
};

export default connect(mapStateToProps, mapDispatchToProps)(SnackBar);
